// extracted by mini-css-extract-plugin
export default {"EditChild":"EditChild_EditChild__3vD7j","EditChild-Card":"EditChild_EditChild-Card__n1tJu"};